module.exports = __webpack_public_path__ + "static/media/logo.ae6cf15e.svg";